module.exports = __webpack_public_path__ + "whitewaterbottle.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitewaterbottle.png
// module id = 908
// module chunks = 0